module.exports = __webpack_public_path__ + "93c8ecd0efabbd80ad9c25f34507b2be.svg";